interface CategoryIndex {
  id: string;
  name: string;
}

document.addEventListener("DOMContentLoaded", async () => {
  try {
    const response = await fetch("/catalog/catalog_sheets/index.json?t=" + new Date().getTime(), {
      cache: "no-store",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const categories: CategoryIndex[] = await response.json();
    renderCategoryNav(categories);
  } catch (error) {
    console.error("Error loading categories list:", error);
    const navContainer = document.getElementById("category-nav");
    if (navContainer) {
      navContainer.innerHTML =
        '<div class="error-msg">Failed to load categories. Please try again later.</div>';
    }
  }
});

function renderCategoryNav(categories: CategoryIndex[]) {
  const navContainer = document.getElementById("category-nav");
  if (!navContainer) return;

  navContainer.innerHTML = "";

  if (categories.length === 0) {
    navContainer.innerHTML = '<div class="empty-msg">No product categories available.</div>';
    return;
  }

  categories.forEach((category) => {
    const link = document.createElement("a");
    // If we have a direct link in the json (for standalone apps like Diamond Burs), use it.
    // Otherwise route exactly like before via query string.
    link.href = (category as any).link || `/catalog/?category=${encodeURIComponent(category.id)}`;
    link.className = "category-card";

    // Add an icon or just the text
    link.innerHTML = `
      <div class="category-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
      </div>
      <h3>${escapeHtml(category.name)}</h3>
    `;

    navContainer.appendChild(link);
  });
}

function escapeHtml(unsafe: string) {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
